import React from 'react';
import CourseTemplate from '../../components/CourseTemplate';

const MPharmCoursePage: React.FC = () => {
  const courseData = {
    title: "M.Pharm (Master of Pharmacy)",
    shortName: "M.Pharm",
    duration: "2 years",
    description: "Advanced postgraduate program in pharmaceutical sciences focusing on drug development, formulation, and research",
    overview: "Master of Pharmacy (M.Pharm) is a 2-year postgraduate program that provides advanced knowledge in pharmaceutical sciences, drug discovery, formulation technology, and pharmacology. Students learn advanced research techniques, regulatory affairs, quality assurance, and pharmaceutical management. The program emphasizes both theoretical knowledge and practical laboratory work, preparing students for careers in pharmaceutical research, quality control, and drug development.",
    eligibility: [
      "Bachelor's degree in Pharmacy (B.Pharm)",
      "Minimum 55% marks in B.Pharm",
      "Valid GATE/State PG entrance exam score",
      "Proficiency in English"
    ],
    
    curriculum: [
      {
        year: 1,
        subjects: [
          "Advanced Pharmaceutical Chemistry",
          "Advanced Pharmacology",
          "Pharmaceutical Analysis",
          "Medicinal Chemistry",
          "Pharmaceutics",
          "Pharmacognosy",
          "Regulatory Affairs",
          "Research Methodology"
        ]
      },
      {
        year: 2,
        subjects: [
          "Drug Metabolism and Toxicology",
          "Biopharmaceutics",
          "Quality Assurance",
          "Pharmaceutical Management",
          "Advanced Formulations",
          "Advanced Analysis",
          "Research Project/Dissertation",
          "Industrial Internship"
        ]
      }
    ],

    careerProspects: {
      roles: [
        "Pharmaceutical Researcher",
        "Quality Assurance Manager",
        "Regulatory Affairs Manager",
        "Drug Development Scientist",
        "Pharmaceutical Analyst",
        "Clinical Research Associate",
        "Product Manager",
        "Pharmaceutical Consultant",
        "Academic Researcher",
        "Pharmaceutical Patent Attorney"
      ],
      industries: [
        "Pharmaceutical Manufacturing",
        "Drug Research & Development",
        "Quality Control & Assurance",
        "Regulatory Affairs",
        "Clinical Research Organizations",
        "Biotech Companies",
        "Government Laboratories",
        "Academic Institutions",
        "Pharmaceutical Consulting",
        "Export Organizations"
      ],
      averageSalary: "₹5-8 LPA (Fresher), ₹15-40 LPA (Experienced)",
      topRecruiters: [
        "Cipla",
        "Dr. Reddy's Laboratories",
        "Lupin",
        "Aurobindo Pharma",
        "Sun Pharmaceutical",
        "CSIR Institutes",
        "IICT",
        "Pharmaceutical Research Organizations",
        "MNCs (Pfizer, Roche, GSK)",
        "CROs (Synchron, Covance)"
      ]
    },

    admissionProcess: [
      "Merit-based selection through entrance exam (GATE/State PG entrance)",
      "Written examination and interview",
      "Application form submission",
      "Document verification",
      "Counseling and seat allocation"
    ],

    topColleges: [
      {
        name: "Manipal College of Pharmaceutical Sciences",
        location: "Manipal, Karnataka",
        fees: "₹2-3 LPA",
        ranking: "NIRF Ranking: 15 (Pharmacy)"
      },
      {
        name: "JSS College of Pharmacy",
        location: "Ooty, Tamil Nadu",
        fees: "₹2 LPA",
        ranking: "Accredited by AICTE"
      },
      {
        name: "Delhi Institute of Pharmaceutical Sciences & Research",
        location: "Delhi",
        fees: "₹60,000 (Annual)",
        ranking: "Government Institute"
      },
      {
        name: "Jamia Hamdard Institute of Pharmaceutical Sciences",
        location: "New Delhi",
        fees: "₹1.5-2 LPA",
        ranking: "Premier Institute"
      }
    ],

    skills: [
      "Pharmaceutical Research",
      "Drug Formulation",
      "Analytical Testing",
      "Quality Management",
      "Regulatory Knowledge",
      "Laboratory Techniques",
      "Data Analysis",
      "Project Management",
      "Scientific Writing",
      "Problem Solving",
      "Team Leadership",
      "Critical Thinking"
    ],

    futureScope: "Growing pharmaceutical sector with increasing R&D investments, expanding biotech industry, international market opportunities, and career advancement in drug development and regulatory roles.",

    faqs: [
      {
        question: "Is M.Pharm essential for pharmacy practice?",
        answer: "M.Pharm is not mandatory for practice but enhances career prospects significantly, especially in research, quality control, and management positions. It opens doors to government jobs and higher positions in pharmaceutical companies."
      },
      {
        question: "What is the scope of M.Pharm in abroad?",
        answer: "M.Pharm graduates can pursue PhD programs, work in international pharmaceutical companies, or seek opportunities in countries like USA, UK, Canada, and Australia with additional certifications or credentials evaluation."
      },
      {
        question: "Can I do M.Pharm while working?",
        answer: "Some universities offer part-time M.Pharm programs. However, full-time programs are more common due to intensive laboratory work and research requirements. Check with specific universities for flexible options."
      },
      {
        question: "What is the difference between M.Pharm and PhD in Pharmacy?",
        answer: "M.Pharm is a 2-year coursework-based postgraduate degree focused on industry readiness. PhD is 3-4 years research-focused program for academic and research careers. M.Pharm graduates can pursue PhD later."
      }
    ]
  };

  return (
    <div className="min-h-screen w-full bg-gradient-to-br from-[#0f172a] via-[#1e293b] to-black flex flex-col items-center justify-start py-8 px-2">
      <h1 className="text-4xl md:text-5xl font-extrabold text-transparent bg-clip-text bg-gradient-to-r from-cyan-400 via-pink-400 to-purple-400 drop-shadow-glow mb-6 text-center animate-glow">
        {courseData.title}
      </h1>
      <div className="w-full max-w-4xl">
        <CourseTemplate courseData={courseData} />
      </div>
    </div>
  );
};

export default MPharmCoursePage;
